import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const FormEntitiesApi = createApi({
	reducerPath: "FormEntities",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND2_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
		credentials: "include",
	}),
	tagTypes: ["Entities", "EntityData"],
	endpoints: (builder) => ({
		getAllEntities: builder.query({
			query: () => `/v1/form-entities`,
			providesTags: ["Entities"],
		}),
		getEntityMetadata: builder.query({
			query: (entityKey) => `/v1/form-entities/${entityKey}`,
			providesTags: (result, error, entityKey) => [
				{ type: "Entities", id: entityKey },
			],
		}),
			getEntityData: builder.query({
				query: ({ entityKey, displayField, search, limit = 50, offset = 0, parentEntityKey, parentValue, includeProperties = [] }) => {
				const params = new URLSearchParams();
				if (displayField) params.append("displayField", displayField);
				if (search) params.append("search", search);
				if (limit) params.append("limit", limit.toString());
				if (offset) params.append("offset", offset.toString());
					if (parentEntityKey) params.append("parentEntityKey", parentEntityKey);
					if (parentValue) params.append("parentValue", parentValue.toString());
					if (includeProperties.length > 0) {
						params.append("includeProperties", includeProperties.join(","));
					}

				return `/v1/form-entities/${entityKey}/data?${params.toString()}`;
			},
			providesTags: (result, error, { entityKey }) => [
				{ type: "EntityData", id: entityKey },
			],
		}),
		getValidParents: builder.query({
			query: (entityKey) => `/v1/form-entities/${entityKey}/valid-parents`,
			providesTags: (result, error, entityKey) => [
				{ type: "Entities", id: `${entityKey}-parents` },
			],
		}),
		validateEntityConfig: builder.mutation({
			query: ({ entityKey, config }) => ({
				url: `/v1/form-entities/${entityKey}/validate`,
				method: "POST",
				body: config,
			}),
		}),
		resolveDisplayValue: builder.query({
			query: ({ entityKey, id, displayField }) => {
				const params = new URLSearchParams();
				if (displayField) params.append("displayField", displayField);
				
				return `/v1/form-entities/${entityKey}/resolve/${id}?${params.toString()}`;
			},
		}),
	}),
});

export const {
	useGetAllEntitiesQuery,
	useGetEntityMetadataQuery,
	useGetEntityDataQuery,
	useLazyGetEntityDataQuery,
	useGetValidParentsQuery,
	useValidateEntityConfigMutation,
	useResolveDisplayValueQuery,
	useLazyResolveDisplayValueQuery,
} = FormEntitiesApi;
